import { ReactNode, useId } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/Overlay";
import "./tooltip-trigger-view.scss";
//<editor-fold desc="Props">
export interface TooltipTriggerProps {
  tipKey: string;
  tip?: string;
  tipClass?: string;
  wrapDisabled?: boolean;
  children: ReactNode;
  placement?: Placement;
  delay?: number | { show: number; hide: number };
}
//</editor-fold>

function TooltipTrigger(props: any) {
  const {
    tipKey,
    tip,
    wrapDisabled,
    children,
    placement,
    className,
    tipClass,
    delay,
  } = props;
  let content;
  const idPrefix = useId();
  if (wrapDisabled) {
    content = (
      <div className={"tooltip-disabled-wrapper " + (className || "")}>
        {children}
      </div>
    );
  } else {
    content = children;
  }
  let rDelay = delay || { show: 300, hide: 100 };
  return (
    <>
      {tip && (
        <OverlayTrigger
          delay={rDelay}
          placement={placement || "auto"}
          key={tipKey}
          overlay={
            <Tooltip className={tipClass} id={idPrefix + tipKey + `-tip`}>
              {tip}
            </Tooltip>
          }
          popperConfig={{
            modifiers: [
              {
                name: "flip",
                options: {
                  boundary: "viewport",
                },
              },
              {
                name: "preventOverflow",
                options: {
                  boundariesElement: "viewport",
                  altAxis: true,
                },
              },
            ],
          }}
        >
          {content}
        </OverlayTrigger>
      )}
      {!tip && children}
    </>
  );
}
export default TooltipTrigger;
